import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

export default function PhilosophySection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });
  const { t } = useLanguage();

  return (
    <section
      ref={ref}
      className="bg-black overflow-hidden"
      style={{ paddingTop: '7rem', paddingBottom: '10rem', paddingLeft: '1.5rem', paddingRight: '1.5rem' }}
    >
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="text-5xl md:text-7xl lg:text-8xl text-white tracking-tight mb-16 md:mb-24"
        >
          {t('philosophy.h1')}{' '}
          <em style={{ fontFamily: "'Instrument Serif', serif", fontStyle: 'italic', color: 'rgba(255,255,255,0.35)' }}>
            {t('philosophy.h1x')}
          </em>{' '}
          {t('philosophy.h1b')}
        </motion.h2>

        {/* Two-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
          {/* Left: Video */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="rounded-3xl overflow-hidden"
            style={{ aspectRatio: '4/3' }}
          >
            <video
              muted
              autoPlay
              loop
              playsInline
              preload="auto"
              className="w-full h-full object-cover"
            >
              <source src="https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260307_083826_e938b29f-a43a-41ec-a153-3d4730578ab8.mp4" type="video/mp4" />
            </video>
          </motion.div>

          {/* Right: Text blocks */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col justify-center gap-8"
          >
            <div>
              <p className="text-white/40 text-xs tracking-widest uppercase mb-4">
                {t('philosophy.block1l')}
              </p>
              <p className="text-white/70 text-base md:text-lg leading-relaxed">
                {t('philosophy.block1')}
              </p>
            </div>

            <div className="w-full" style={{ height: '1px', background: 'rgba(255,255,255,0.08)' }} />

            <div>
              <p className="text-white/40 text-xs tracking-widest uppercase mb-4">
                {t('philosophy.block2l')}
              </p>
              <p className="text-white/70 text-base md:text-lg leading-relaxed">
                {t('philosophy.block2')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
